module.exports = __webpack_public_path__ + "img/icon-headphones-on.99bfaf9.webp";